import { Controller } from "@hotwired/stimulus"

// タブが幅に収まらず選択中タブが隠れるとき、中央へ寄せる
// (scrollIntoView と違い scrollLeft の直接操作はページ側を動かさない)
export default class extends Controller {
  connect() {
    // 回転・ウィンドウ縮小で溢れ始めても DOM は差し替わらず connect が来ないため ResizeObserver で追う
    // (observe した時点で 1 回発火するので初回の寄せも兼ねる)
    this.observer = new ResizeObserver(() => this.#center())
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  #center() {
    if (this.element.scrollWidth <= this.element.clientWidth) return

    const active = this.element.querySelector('[aria-selected="true"]')
    if (!active) return

    const navRect = this.element.getBoundingClientRect()
    const activeRect = active.getBoundingClientRect()
    // 全体が見えているなら動かさない (ユーザーが手で送ったスクロール位置を保つ)
    if (activeRect.left >= navRect.left && activeRect.right <= navRect.right) return

    const offsetInNav = activeRect.left - navRect.left
    const centeringGap = (navRect.width - activeRect.width) / 2

    this.element.scrollLeft += offsetInNav - centeringGap
  }
}
